module.exports = __webpack_public_path__ + "img/HongKongTrustSwper1.f41432e6.png";